import { DeliveryZoneApiFactory, DeliveryZoneBase } from '@flipdish/api-client-typescript';

import { createApi } from '../helpers/utilities';
import { type ServerError, mapServerError } from './utils/serverErrorMapper';

const DeliveryZonesApi = createApi(DeliveryZoneApiFactory);

const mapServerErrorOrThrowOriginal = async (incomingMessage: unknown): Promise<ServerError> => {
  try {
    return await mapServerError(incomingMessage);
  } catch {
    throw incomingMessage;
  }
};

export const loadAll = (storeId: number) => {
  return DeliveryZonesApi.getDeliveryZones(storeId).then((response) => {
    return response.Data;
  });
};

export const create = async (storeId: number, zone: DeliveryZoneBase) => {
  try {
    const response = await DeliveryZonesApi.addDeliveryZone(storeId, zone);
    return response.Data;
  } catch (incomingMessage) {
    throw await mapServerErrorOrThrowOriginal(incomingMessage);
  }
};

export const update = async (storeId: number, deliveryZoneid: number, zone: DeliveryZoneBase) => {
  try {
    const response = await DeliveryZonesApi.updateDeliveryZone(storeId, deliveryZoneid, zone);
    return response.Data;
  } catch (incomingMessage) {
    throw await mapServerErrorOrThrowOriginal(incomingMessage);
  }
};

export const remove = (storeId: number, deliveryZoneid: number) =>
  DeliveryZonesApi.removeDeliveryZone(storeId, deliveryZoneid);
